import { TextField, Button } from '@mui/material'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useEffect } from 'react'
import axiosInstance from '../utils/axios'

export default function CampaignForm({ originalData, onSubmitForm }) {
  // Form for campaigns, may be used for creating or editing campaigns
  // should use the useForm hook from react-hook-form and yup for schema validation
  // Sample data:
  /*
  {
    "name": "Red shoes",
    "budget": 2345,
    "start": "2025-08-12T12:31:33Z",
    "end": "2025-09-03T12:31:33Z",
  }
 */

  const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    budget: yup.number().required('Budget is required'),
    start: yup.date().required('Start is required'),
    end: yup.date().required('End is required'),
  })

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  const formatDate = (date) => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
  }

  useEffect(() => {
    if (originalData) {
      setValue('name', originalData.name)
      setValue('budget', originalData.budget)
      const startDate = new Date(originalData.start)
      const endDate = new Date(originalData.end)
      setValue('start', formatDate(startDate))
      setValue('end', formatDate(endDate))
    }
  }, [originalData])

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitForm)} style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '500px', marginTop: 10}}>
        <TextField
          label="Name"
          name="name"
          {...register('name')}
          error={!!errors.name}
          helperText={errors.name?.message}
        />
        <TextField
          label="Budget"
          name="budget"
          {...register('budget')}
          error={!!errors.budget}
          helperText={errors.budget?.message}
        />
        <TextField
          id="start"
          label="Start"
          type="date"
          {...register('start')}
          sx={{ width: '100%' }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          id="end"
          label="End"
          type="date"
          {...register('end')}
          sx={{ width: '100%' }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      {errors.first && <p>{errors.first.message}</p>}
      <Button style={{ width: '100%' }} type="submit" variant="contained" color="primary">Submit</Button>
      </form>
    </div>
  )
}
